import { render, staticRenderFns } from "./VerifyPage.vue?vue&type=template&id=268abc82"
import script from "./VerifyPage.vue?vue&type=script&lang=js"
export * from "./VerifyPage.vue?vue&type=script&lang=js"
import style0 from "./VerifyPage.vue?vue&type=style&index=0&id=268abc82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports